import { render } from "./ImplantsGoldStandard.vue?vue&type=template&id=21d9b4a0"
import script from "./ImplantsGoldStandard.vue?vue&type=script&lang=js"
export * from "./ImplantsGoldStandard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__